import { CarrierAndServiceSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import * as z from "zod";

export const getCarrierServiceCombinations = {
  name: "getCarrierServiceCombinations" as const,
  input: z.object({
    includeDisabled: z.boolean(),
    includeMerchantCarriers: z.boolean(),
  }),
  output: z.object({ options: z.array(CarrierAndServiceSchema) }),
};
